<template>
  <div>
    <vx-card card-background="#021a33" style="padding: 10px 14px;">
      <vs-row vs-type="flex" vs-w="12">
        <vs-col
          vs-w="8"
          vs-type="flex"
          vs-direction="column"
          vs-justify="flex-start"
          vs-align="flex-start"
          style="display: flex; flex-direction: column;"
        >
          <h5 style="color: white; font-weight: 700; margin-bottom: 4px;">ROTAS: {{ rotas.length }}</h5>
          <div style="font-size: 12px; color: #e2e8f0; display: flex; flex-direction: column; gap: 3px; text-align: left; margin-top: 4px;">
            <span>Total Associado: <strong style="color: #fbbf24; font-size: 13px;">{{ totalAssociado }}</strong></span>
            <span>Total Retornos: <strong style="color: #38bdf8; font-size: 13px;">{{ totalRetornos }}</strong></span>
          </div>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
        >
          <div>
            <ModalCadastroRota @update="getRotas()" />
          </div>
        </vs-col>
      </vs-row>
    </vx-card>
    <VuePerfectScrollbar
      class="scroll-rota-lista"
      :settings="settings"
      style="background-color: #ebebeb"
    >
      <div id="rotaListaOsAssoc" class="vs-con-loading__container">
        <div v-if="!rotas.length > 0">
          <div class="con-colors mt-10 mb-20">
            <ul>
              <span
                class="px-3 pt-2"
                style="color: grey !important; font-weight: 1000 !important"
              >
                <vs-icon size="large" icon="sentiment_dissatisfied"></vs-icon>
              </span>
            </ul>
          </div>
        </div>
        <vs-list v-for="rota in rotas" :key="rota.id">
          <vx-card :class="classeCard(rota.id)" @click="aoClicarCard(rota)">
            <template slot="no-body">
              <div class="rota-vx-card-body">
                <vs-row
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                >
                  <vs-col
                    class="pt-3 px-2"
                    :class="{ 'pb-3': !temResumo(rota) }"
                    vs-w="12"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="flex-start"
                  >
                    <div class="rota-card-inner">
                      <div class="rota-linha-cabecalho">
                        <div class="rota-nome-wrap">
                          <h4 class="rota-nome mb-0">
                            <b>{{ rota.nome }}</b>
                          </h4>
                          <div class="rota-tecnico">
                            <span style="vertical-align: middle;">
                              {{ rota.id_tecnico_responsavel && rota.tecnico && rota.tecnico.nome ? rota.tecnico.nome : 'Sem responsável' }}
                            </span>
                          </div>
                        </div>
                        <span
                          class="os-badge rota-id-pill"
                          title="Identificador interno da rota"
                        >
                          <span class="rota-id-pill__label">ID</span>
                          <span class="rota-id-pill__num">{{ rota.id }}</span>
                        </span>
                        <span
                          v-if="rota.id_tipo_veiculo"
                          class="os-badge rota-badge-tipo"
                          :class="classeBadgeTipoVeiculo(rota.id_tipo_veiculo)"
                          title="Tipo de veículo"
                        >
                          {{ labelTipoVeiculo(rota.id_tipo_veiculo) }}
                        </span>
                        <div
                          v-if="mostrarBotaoEditar"
                          class="rota-edit-wrap"
                          @click.stop
                        >
                          <ModalEditarRota
                            @update="getRotas()"
                            :rota="rota"
                            class="rota-edit-compact"
                          />
                        </div>
                      </div>
                    </div>
                  </vs-col>
                </vs-row>
                <div v-if="temResumo(rota)" class="rota-stats-strip">
                  <div class="rota-stats-chips">
                    <span
                      class="rota-chip rota-chip--total"
                      title="Total de serviços na rota"
                    >
                      <span class="rota-chip-l">Total</span>
                      <span class="rota-chip-n">{{ num(rota.total_os) }}</span>
                    </span>
                    <span class="rota-chip rota-chip--ok" title="Executadas">
                      <span class="rota-chip-l">Exec.</span>
                      <span class="rota-chip-n">{{
                        num(rota.executados)
                      }}</span>
                    </span>
                    <span
                      class="rota-chip rota-chip--pend"
                      title="Pendentes ou não executadas"
                    >
                      <span class="rota-chip-l">Não exec.</span>
                      <span class="rota-chip-n">{{
                        num(rota.nao_executados)
                      }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </vx-card>
        </vs-list>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import ModalCadastroRota from "../rotas/components/cadastro";
import ModalEditarRota from "../rotas/components/editar";
import { labelTipoVeiculo } from "@/constants/tiposVeiculo";

export default {
  name: "RotaListaOsAssoc",
  props: {
    blocked: Boolean,
    filtro: { type: Object, required: true },
    painelRotasTick: { type: Number, default: 0 },
    mostrarBotaoEditar: { type: Boolean, default: true },
    historicoRotas: { type: Array, default: null },
  },
  data() {
    return {
      selectedRot: null,
      settings: { maxScrollbarLength: 60, wheelSpeed: 0.8 },
      rotas: [],
    };
  },
  methods: {
    labelTipoVeiculo,
    classeBadgeTipoVeiculo(id) {
      return Number(id) === 2 ? "badge-warning" : "badge-success";
    },
    num(v) {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    },
    temResumo(rota) {
      return rota.total_os != null;
    },
    classeCard(rotaId) {
      if (this.blocked) {
        return this.selectedRot !== rotaId ? "rota-disabled" : "active-rota";
      }
      return this.selectedRot !== rotaId ? "rota" : "active-rota";
    },
    async aoClicarCard(rota) {
      if (this.blocked) return;
      if (this.selectedRot === rota.id) {
        this.selectedRot = null;
        this.$emit("update", { id: null, nome: null });
        return;
      }
      this.selectedRot = rota.id;
      this.$emit("update", { id: rota.id, nome: rota.nome });
    },
    /** Junta totais do resumo às rotas (por id). */
    mesclarResumoNasRotas(rotas, resumo) {
      if (!resumo || !resumo.length) {
        return rotas.map((r) => ({
          ...r,
          total_os: 0,
          executados: 0,
          nao_executados: 0,
        }));
      }
      const porId = {};
      for (const r of resumo) {
        porId[r.id] = r;
      }
      return rotas.map((r) => {
        const s = porId[r.id];
        return {
          ...r,
          total_os: s ? s.total_os : 0,
          executados: s ? s.executados : 0,
          nao_executados: s ? s.nao_executados : 0,
        };
      });
    },
    async getRotas() {
      await this.$vs.loading({ container: "#rotaListaOsAssoc", scale: 0.6 });
      try {
        if (this.historicoRotas) {
          const rawRotas = await this.$http.get("rota");
          const filtradas = rawRotas.filter((r) => r.levantamento == 0);
          const resumoHistorico = this.historicoRotas.map((r) => ({
            id: r.id,
            total_os: r.os.length,
            executados: r.os.filter((o) => o.executado == 1).length,
            nao_executados: r.os.filter((o) => o.executado == 2).length,
          }));
          this.rotas = this.mesclarResumoNasRotas(filtradas, resumoHistorico);
          this.$emit("rotaEmit", this.rotas);
          return;
        }
        const [rawRotas, resumo] = await Promise.all([
          this.$http.get("rota"),
          this.$http.post("getRotasResumoOs", this.filtro).catch(() => null),
        ]);
        const filtradas = rawRotas.filter((r) => r.levantamento == 0);
        this.rotas = resumo
          ? this.mesclarResumoNasRotas(filtradas, resumo)
          : filtradas;
        this.$emit("rotaEmit", this.rotas);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#rotaListaOsAssoc > .con-vs-loading");
      }
    },
  },
  computed: {
    totalAssociado() {
      return this.rotas.reduce((sum, r) => sum + (Number(r.total_os) || 0), 0);
    },
    totalRetornos() {
      return this.rotas.reduce((sum, r) => sum + (Number(r.executados) || 0) + (Number(r.nao_executados) || 0), 0);
    }
  },
  watch: {
    painelRotasTick() {
      this.getRotas();
    },
  },
  components: { ...components, ModalCadastroRota, ModalEditarRota },
};
</script>

<style lang="scss" scoped>
.rota-disabled {
  background-color: #f0f0f0;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition: background 0.1s ease-in-out;
  transition: 0.1s;
  border-radius: 5px;
  font-size: 16px;
  cursor: not-allowed;
  h4,
  h6 {
    color: #7c7c7c;
  }
  .rota-nome,
  .rota-chip-l,
  .rota-chip-n {
    color: #737373 !important;
  }
  .rota-chip {
    background: #e5e5e5 !important;
  }
}
.rota {
  background-color: #fff;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition: background 0.1s ease-in-out;
  transition: 0.1s;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  color: #ffca00 !important;
}
.rota:hover {
  transition: 0.1s;
  background: #eeeeee;
  transform: translateY(-3px);
}
.active-rota {
  background-color: #e8f4f1;
  border: 2px solid #0f766e;
  box-sizing: border-box;
  transition: background 0.15s ease-in-out, border-color 0.2s ease;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
.scroll-rota-lista {
  max-height: 65vh !important;
}
.rota .rota-card-inner,
.rota .rota-nome {
  color: #0f172a !important;
}
.active-rota .rota-card-inner,
.active-rota .rota-nome {
  color: #0f172a !important;
}
.rota-linha-cabecalho {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  width: 100%;
}
.rota-linha-cabecalho .rota-nome-wrap {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.rota-linha-cabecalho .rota-nome {
  word-break: break-word;
  text-align: left;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 600;
}
.rota-linha-cabecalho .rota-nome b {
  font-weight: 700;
}
.rota-linha-cabecalho .rota-tecnico {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  display: flex;
  align-items: center;
}
.rota-linha-cabecalho .rota-id-pill,
.rota-linha-cabecalho .rota-badge-tipo {
  flex: 0 0 auto;
}
.rota-linha-cabecalho .rota-edit-wrap {
  flex: 0 0 auto;
  margin-left: auto;
  line-height: 1;
}
.rota-stats-strip {
  width: 100%;
  box-sizing: border-box;
  padding: 2px;
  margin-top: 4px;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
}
.active-rota .rota-stats-strip {
  border-top-color: rgba(15, 23, 42, 0.1);
}
.rota-stats-chips {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 2px;
  width: 100%;
  box-sizing: border-box;
}
.rota-chip {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 4px 2px;
  border-radius: 4px;
  line-height: 1.15;
  text-align: center;
  box-sizing: border-box;
}
.rota-chip-l {
  font-size: 9px;
  font-weight: 600;
  opacity: 0.88;
  line-height: 1.1;
}
.rota-chip-n {
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.rota .rota-chip--total {
  background: rgba(15, 23, 42, 0.06) !important;
}
.rota .rota-chip--total .rota-chip-n {
  color: #0f172a !important;
}
.rota .rota-chip--ok {
  background: rgba(13, 148, 136, 0.1) !important;
}
.rota .rota-chip--ok .rota-chip-n {
  color: #0d9488 !important;
}
.rota .rota-chip--pend {
  background: rgba(180, 83, 9, 0.1) !important;
}
.rota .rota-chip--pend .rota-chip-n {
  color: #b45309 !important;
}
.rota .rota-chip-l {
  color: #475569 !important;
}
.active-rota .rota-chip--total {
  background: rgba(15, 23, 42, 0.06) !important;
}
.active-rota .rota-chip--total .rota-chip-n {
  color: #0f172a !important;
}
.active-rota .rota-chip--ok {
  background: rgba(13, 148, 136, 0.12) !important;
}
.active-rota .rota-chip--ok .rota-chip-n {
  color: #0d9488 !important;
}
.active-rota .rota-chip--pend {
  background: rgba(180, 83, 9, 0.12) !important;
}
.active-rota .rota-chip--pend .rota-chip-n {
  color: #b45309 !important;
}
.active-rota .rota-chip-l {
  color: #475569 !important;
}
.rota-id-pill {
  gap: 5px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid rgba(15, 23, 42, 0.08);
}
.rota-id-pill__label {
  opacity: 0.9;
  text-transform: uppercase;
}
.rota-id-pill__num {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
}
.active-rota .rota-id-pill {
  background: #dff0ec;
  border-color: rgba(15, 118, 110, 0.25);
  color: #334155;
}
.rota-disabled .rota-id-pill {
  background: #e5e7eb;
  border-color: #d1d5db;
  color: #6b7280;
}
.os-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 999px;
  white-space: nowrap;
  letter-spacing: 0.02em;
}
.badge-success {
  background: #d1fae5;
  color: #065f46;
}
.badge-warning {
  background: #fef3c7;
  color: #92400e;
}
.rota-disabled .os-badge.badge-success,
.rota-disabled .os-badge.badge-warning {
  background: #e5e7eb;
  color: #6b7280;
}
.rota-edit-compact ::v-deep a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  line-height: 1;
}
.rota-edit-compact ::v-deep .feather-icon {
  width: 15px !important;
  height: 15px !important;
  margin-right: 0 !important;
}
.rota .rota-edit-compact ::v-deep .feather-icon,
.active-rota .rota-edit-compact ::v-deep .feather-icon {
  color: #0d9488 !important;
}
.rota-disabled .rota-edit-compact ::v-deep .feather-icon {
  color: #a3a3a3 !important;
}
.rota-vx-card-body {
  width: 100%;
  box-sizing: border-box;
}
.rota-card-inner {
  width: 100%;
  text-align: left;
}
</style>
